import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6f046f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { SlotItem } from "@/types/Calendar";
import { NText, NDivider, NScrollbar, NSpace, NTag, NCard } from "naive-ui"


export default /*#__PURE__*/_defineComponent({
  __name: 'CalenderPop',
  props: {
    slotItems: null,
    date: null
  },
  setup(__props: any) {

const props = __props as {
    slotItems: SlotItem[],
    date: number
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    bordered: false,
    size: "medium",
    role: "dialog",
    "aria-modal": "true",
    style: {"width":"20em"},
    class: "calendar-pop"
  }, {
    header: _withCtx(() => [
      _createVNode(_unref(NSpace), { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NTag), {
            type: "primary",
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.date), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(NScrollbar), { style: {"max-height":"25em"} }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slotItems, (slotItem) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: slotItem }, [
              _createVNode(_unref(NDivider), { class: "pop-divider" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NText), { depth: "3" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(slotItem.start.toTimeString().slice(0,5)) + " - " + _toDisplayString(slotItem.end.toTimeString().slice(0,5)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", {
                innerHTML: slotItem.description
              }, null, 8, _hoisted_1)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})